function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Body } from '../../atoms';
import ReactConfigContext from '../../ReactConfigContext';
export default function TeamCard(param) {
    var image = param.image, name = param.name, role = param.role, subtitle = param.subtitle, action = param.action, className = param.className;
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, ImageComponent = _useContext_config.ImageComponent, LinkComponent = _useContext_config.LinkComponent;
    var cardContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "aspect-w-1 aspect-h-1 overflow-hidden safari-fix-transform rounded-full"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        className: twMerge(image.className, 'w-full h-full object-cover object-center')
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "mt-6 text-center"
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "md",
        className: "leading-tight"
    }, name), !!(role || subtitle) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-3 font-semibold text-body-base leading-normal grid grid-cols-1 grid-flow-row auto-rows-max gap-1"
    }, !!role && /*#__PURE__*/ React.createElement("div", null, role), !!subtitle && /*#__PURE__*/ React.createElement("div", null, subtitle))));
    if (action) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
            className: twMerge(className, action.className)
        }), /*#__PURE__*/ React.createElement("article", null, cardContent));
    }
    return /*#__PURE__*/ React.createElement("article", {
        className: className
    }, cardContent);
}

//# sourceMappingURL=TeamCard.js.map